export default "__VITE_ASSET__em9ShLQK__"